// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_fi-0";
export var fulfillmentPanelBody = "_fi-1";